export const model = {
  Code: '',
  Username: '',
  FirstName: '',
  LastName: '',
};
